import Component from 'classes/Component'

export default class Select extends Component {
    constructor({el}) {
        super()

        this.el = el
        this.parent = this.el.parentNode
    }

    init() {
        super.init()

        if (!this.el.classList.contains('select')) {
            this.el.classList.add('select')
        }

        this.options = []
        this.optionEls = this.el.querySelectorAll('option')
        this.placeholderText = this.optionEls[0].textContent

        this.wrapper = document.createElement('span')
        this.label = document.createElement('span')
        this.labelInner = document.createElement('span')
        this.dropdown = document.createElement('span')

        this.wrapper.classList.add('select-wrapper')
        this.label.classList.add('select-label')
        this.labelInner.classList.add('select-label-inner')
        this.dropdown.classList.add('select-dropdown')
        this.dropdown.setAttribute('data-lenis-prevent', '1')

        this.label.setAttribute('role', 'combobox')
        this.label.setAttribute('tabindex', '0')
        this.label.setAttribute('aria-haspopup', 'listbox')
        this.label.setAttribute('aria-expanded', 'false')

        const selectId = this.el.getAttribute('id') || ('select-' + Math.random().toString(36).slice(2))
        this.label.setAttribute('aria-controls', selectId + '-dropdown')
        this.dropdown.setAttribute('role', 'listbox')
        this.dropdown.setAttribute('id', selectId + '-dropdown')

        this.labelInner.textContent = this.placeholderText

        this.parent.insertBefore(this.wrapper, this.el)
        this.wrapper.appendChild(this.label)
        this.label.appendChild(this.labelInner)
        this.wrapper.appendChild(this.dropdown)
        this.wrapper.appendChild(this.el)

        this.addEventHandler({
            el: document,
            event: 'click',
            handler: this.onDocumentClick.bind(this)
        })

        this.addEventHandler({
            el: this.label,
            event: 'click',
            handler: this.toggle.bind(this)
        })

        this.addEventHandler({
            el: this.label,
            event: 'keydown',
            handler: this.onLabelKeydown.bind(this)
        })

        this.optionEls.forEach((el, i) => {
            const optionEl = document.createElement('span')
            optionEl.classList.add('select-option')
            optionEl.innerHTML = el.textContent
            optionEl.setAttribute('data-value', el.value)
            optionEl.setAttribute('data-index', i)
            optionEl.setAttribute('role', 'option')
            optionEl.setAttribute('tabindex', '-1')

            this.dropdown.appendChild(optionEl)

            this.addEventHandler({
                el: optionEl,
                event: 'click',
                handler: this.onOptionClick.bind(this)
            })

            this.addEventHandler({
                el: optionEl,
                event: 'keydown',
                handler: (e) => this.onOptionKeydown(e, i)
            })

            this.options.push({
                el: optionEl,
                index: i,
                value: el.textContent
            })
        })
    }

    onDocumentClick(e) {
        const target = e.target

        if (this.wrapper && !this.wrapper.contains(target)) {
            this.hide()
        }
    }

    toggle() {
        if (this.wrapper.classList.contains('active')) {
            this.hide()
        } else {
            this.show()
        }
    }

    show() {
        this.wrapper.classList.add('active')
        this.label.setAttribute('aria-expanded', 'true')
    }

    hide() {
        this.wrapper.classList.remove('active')
        this.label.setAttribute('aria-expanded', 'false')
    }

    onLabelKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            this.toggle()
            if (this.wrapper.classList.contains('active') && this.options.length) {
                this.options[0].el.focus()
            }
        } else if (e.key === 'Escape') {
            this.hide()
        } else if (e.key === 'ArrowDown') {
            e.preventDefault()
            this.show()
            if (this.options.length) this.options[0].el.focus()
        }
    }

    onOptionKeydown(e, index) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            this.options[index].el.dispatchEvent(new Event('click'))
            this.label.focus()
        } else if (e.key === 'Escape') {
            this.hide()
            this.label.focus()
        } else if (e.key === 'ArrowDown') {
            e.preventDefault()
            const next = this.options[index + 1]
            if (next) next.el.focus()
        } else if (e.key === 'ArrowUp') {
            e.preventDefault()
            if (index === 0) {
                this.label.focus()
            } else {
                this.options[index - 1].el.focus()
            }
        }
    }

    onOptionClick(e) {
        const option = e.target
        const changeEvent = new Event('change')

        this.el.value = option.getAttribute('data-value')

        this.labelInner.innerHTML = option.textContent
        this.el.dispatchEvent(changeEvent)
        this.hide()
    }

    pageLoaded() {
        super.pageLoaded()
    }

    update() {
        super.update()
    }

    resize() {
        super.resize()
    }

    destroy() {
        super.destroy()
    }
}